module.exports = __webpack_public_path__ + "img/xcx-case07.29b8da55.png";